/** Birthday as `YYYY-MM-DD`, interpreted in the visitor's local time zone. */
export type IsoDate = string;

function parts(birthDate: IsoDate): { year: number; month: number; day: number } {
  const [year, month, day] = birthDate.split('-').map(Number);
  return { year, month, day };
}

/** Completed years of life at `now` — increments on the birthday itself. */
export function calculateAge(birthDate: IsoDate, now: Date = new Date()): number {
  const { year, month, day } = parts(birthDate);
  const hadBirthday =
    now.getMonth() + 1 > month || (now.getMonth() + 1 === month && now.getDate() >= day);
  return now.getFullYear() - year - (hadBirthday ? 0 : 1);
}

/**
 * Milliseconds until the next birthday starts (local midnight). A 29 February
 * birthday rolls over to 1 March in non-leap years.
 */
export function msUntilNextBirthday(birthDate: IsoDate, now: Date = new Date()): number {
  const { month, day } = parts(birthDate);
  let next = new Date(now.getFullYear(), month - 1, day);
  if (next.getTime() <= now.getTime()) {
    next = new Date(now.getFullYear() + 1, month - 1, day);
  }
  return next.getTime() - now.getTime();
}
